module.exports = __webpack_public_path__ + "img/individualScore.5a88139b.webp";